import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseSearchLauncherComponent } from '@fuse/components/search-launcher/search-launcher.component';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { SpotLightDialogComponent } from './spotlight-dialog/spotlight-dialog.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FuseSearchLauncherService } from './search-launcher.service';
import { MatChipsModule } from '@angular/material/chips';

@NgModule({
    declarations: [
        FuseSearchLauncherComponent,
        SpotLightDialogComponent
    ],
    imports: [
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        MatDialogModule,
        ReactiveFormsModule,
        MatChipsModule,
        CommonModule
    ],
    exports: [
        FuseSearchLauncherComponent,
        SpotLightDialogComponent
    ],
    providers: [
        FuseSearchLauncherService
    ]
})
export class FuseSearchLauncherModule {
}
